module.exports = __webpack_public_path__ + "static/media/profei.9b2df385.jpg";